import { ConfirmationModal, confirmationModalConfigs } from "components/ActionModals/ConfirmationModal";
import { observer } from "mobx-react-lite";
import { stepBack } from "services";
import { useStores } from "stores";
import { CustomButton } from "ui";

export const StopCollectQuoteButton = observer(() => {
  const { bidCard, actionModals } = useStores();

  const stopQuoteHandler = () => {
    actionModals.open(
      () => (
        <ConfirmationModal
          text="Вы собираетесь остановить сбор котировок"
          successText="Сбор котировок остановлен"
          buttonText="Подтвердить"
          cancelButtonText="Закрыть"
          calledQuery={() => stepBack({ id: bidCard.bid.id })}
          // onSuccess={() => {
          //   setTimeout(() => {
          //     window.updateOnboardingElements?.();
          //   }, 1000);
          // }}
        />
      ),
      {
        ...confirmationModalConfigs,
        title: "Остановка сбора котировок",
        width: "650px",
        onClose: () => actionModals.closeAll(),
      }
    );
  };

  return (
    <CustomButton type="default" onClick={stopQuoteHandler} tooltip="Заявка вернется на предыдущий статус">
      Приостановить сбор котировок
    </CustomButton>
  );
});
